import React from 'react';
import styles from '../../styles/Dashboard/StatusBadge.module.css';

const StatusBadge = ({ status, text }) => {
  const statusClass = {
    received: styles.received,
    pending: styles.pending,
    completed: styles.completed,
    verified: styles.verified,
    processing: styles.processing,
    notCreated: styles.notCreated,
    nonApplicable: styles.nonApplicable,
    userPending: styles.userPending, // <-- add this explicitly
  }[status] || styles.pending;

  return (
    <span className={`${styles.statusBadge} ${statusClass}`}>
      {text || status}
    </span>
  );
};

export default StatusBadge;
